/**
 * PostMessage types for communication between iframe components and WordPress parent window.
 * These constants ensure consistent messaging across all mini-cart components.
 */
export const POST_MESSAGE_TYPES = {
  ADD_TO_CART: 'ADD_TO_CART',
  COOKIE_CONSENT: 'TODOBARRO_COOKIE_CONSENT',
  COOKIE_CONSENT_READY: 'TODOBARRO_IFRAME_READY',
  IFRAME_READY: 'IFRAME_READY',
  SCROLL_TO_IFRAME: 'SCROLL_TO_IFRAME',
  SCROLL_PARENT_BY: 'SCROLL_PARENT_BY',
  LANGUAGE_CHANGE: 'LANGUAGE_CHANGE',
  RESIZE_IFRAME: 'RESIZE_IFRAME',
  UPDATE_CONFIG: 'UPDATE_CONFIG',
} as const

export type PostMessageType
  = (typeof POST_MESSAGE_TYPES)[keyof typeof POST_MESSAGE_TYPES]

/**
 * Helper function to send a standardized cart URL message to WordPress parent.
 */
export function sendAddToCartMessage(cartPath: string): void {
  if (window.parent !== window) {
    const cartUrl = `${window.location.origin}${cartPath}`
    window.parent.postMessage(
      { type: POST_MESSAGE_TYPES.ADD_TO_CART, cartUrl },
      '*',
    )
  }
}
